import { render } from "./PokemonImage.vue?vue&type=template&id=1b4b0c7a&scoped=true"
import script from "./PokemonImage.vue?vue&type=script&lang=js"
export * from "./PokemonImage.vue?vue&type=script&lang=js"

import "./PokemonImage.vue?vue&type=style&index=0&id=1b4b0c7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noahe\\OneDrive\\Documentos\\Udemy - Vue\\Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4b0c7a"]])

export default __exports__